import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { App } from "./App";
import "./styles.css";
import "./mobile-app.css";

// App-like feel on touch: iOS Safari ignores `user-scalable=no` and still
// pinch-zooms, so block its proprietary multi-touch zoom gestures. (Android's
// pinch + double-tap are already covered by the viewport meta + touch-action;
// these events simply never fire there or on desktop.)
for (const evt of ["gesturestart", "gesturechange", "gestureend"]) {
  document.addEventListener(evt, (e) => e.preventDefault(), { passive: false });
}

const rootEl = document.getElementById("root");
if (!rootEl) throw new Error("#root element not found");

createRoot(rootEl).render(
  <StrictMode>
    <App />
  </StrictMode>,
);

// PWA: register the service worker (offline app shell + asset caching) in
// production only — never during `vite dev`, where it would cache the dev
// server and fight HMR. See public/sw.js.
if (import.meta.env.PROD && "serviceWorker" in navigator) {
  // When a freshly-installed SW takes control (it calls skipWaiting +
  // clients.claim), reload ONCE so the user immediately gets the new build
  // instead of a stale cached one. The guard prevents a reload loop.
  let reloadedForUpdate = false;
  navigator.serviceWorker.addEventListener("controllerchange", () => {
    if (reloadedForUpdate) return;
    reloadedForUpdate = true;
    window.location.reload();
  });
  window.addEventListener("load", () => {
    navigator.serviceWorker
      // updateViaCache: "none" → the browser never uses its HTTP cache for the
      // SW script, so a new sw.js is always seen (paired with no-cache headers).
      .register("/sw.js", { updateViaCache: "none" })
      .then((reg) => {
        // Check for a newer SW on every load so deploys propagate promptly.
        reg.update().catch(() => {});
      })
      .catch(() => {
        /* registration is best-effort; the app works without it */
      });
  });
}
